module.exports = __webpack_public_path__ + "img/banner-sm.02daef2a.png";